import type { ComponentProps } from 'preact';
import type { StopDetail } from '../../../../arcticapi/types';
import { Link } from '../../../base/Link/Link';
import { ServedByLinesList } from './ServedByLinesList';
import styles from './StopInfo.module.css';

type StopInfoModel = Pick<
  StopDetail,
  'commonName' | 'indicator' | 'localityName' | 'lines'
>;

export interface StopInfoProps extends Omit<
  ComponentProps<'section'>,
  'children' | 'className'
> {
  stop: StopInfoModel;
  streetViewLink?: string | null;
}

function formatStopTitle(stop: StopInfoModel) {
  const indicator = stop.indicator?.trim();
  return indicator ? `${stop.commonName} (${indicator})` : stop.commonName;
}

export function StopInfo({ stop, streetViewLink, ...props }: StopInfoProps) {
  return (
    <section className={styles.container} {...props}>
      <div className={styles.details}>
        <h3 className={styles.title}>{formatStopTitle(stop)}</h3>
        {stop.localityName && (
          <p className={styles.locality}>{stop.localityName}</p>
        )}
        {streetViewLink && (
          <Link href={streetViewLink} isExternal>
            Open Street View
          </Link>
        )}
      </div>
      {stop.lines && <ServedByLinesList lines={stop.lines} />}
    </section>
  );
}
